module.exports = __webpack_public_path__ + "img/headerCenterLeft.26502fba.png";